<template>
  <v-flex xs12 pt-0 mt-1 style="cursor: pointer" @click.prevent="toogleView">
    <v-layout row wrap>
      <v-flex xs12 py-0>
        <v-container py-3 px-0>
          <v-layout row wrap>
            <v-flex xs6>
              <v-layout row wrap body-1>
                <v-flex xs12 py-0>
                  {{record.receiver.owner_name || record.receiver.company.social_name}}
                </v-flex>
                <v-flex xs12 py-0>
                  {{l(record.value, record.currency)}}
                  <v-icon class="arrow-icon-small">arrow_forward</v-icon>
                  {{record.exchange_currency}} Operações: {{record.count}}
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 py-0 text-xs-right>
              <v-layout row wrap caption>
                <v-flex xs12 py-0>
                  {{longAccountName(record.receiver)}}
                </v-flex>
                <v-flex xs12 py-0>
                  {{longAccountName(record.receiver.intermediary_bank_account)}}
                </v-flex>
              </v-layout>
            </v-flex>

            <transaction @canceledTransaction="canceledTransaction" @exchange_toogle_selected="handleToogleSelected" :record="transaction" v-for="transaction in transactions" :key="transaction.id"  v-if="current_view === 'detailed'" cursor-default/>

            <transition name="fade">
              <v-flex pt-3 xs12 v-if="current_view === 'detailed' && mode === 'normal'" cursor-default>
                <v-layout row wrap body-1>
                  <v-flex xs12 p-0 m-0 v-on:mouseover.stop="" @click.prevent.stop="" :class="{'cursor-default': disableShowExchangeForm}">
                    <v-btn @click="showExchangeForm" block dark class="ma-0 btn-style" :class="{'disable-events': disableShowExchangeForm, 'cursor-default': disableShowExchangeForm}">
                      {{i18n('Realizar Operação de Câmbio')}}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </transition>

            <transition name="fade">
              <v-flex pt-3 xs12 v-if="current_view === 'detailed' && mode === 'confirmation'" cursor-default @click.prevent.stop="">
                <v-layout row wrap body-1>
                  <v-flex xs6 sm3 md2 pr-1>
                    <v-currency-field
                      v-bind="exchange_rate_config"
                      box
                      :readonly="true"
                      v-model="spot_exchange_rate"
                      :label="i18n('Taxa de Câmbio Spot')"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs6 sm2 md2 py-0 pr-1>
                    <v-currency-field
                      v-bind="percentage_config"
                      box
                      :readonly="true"
                      v-model="iof_rate"
                      label="IOF %"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs6 sm2 md2 py-0 pr-1>
                    <v-currency-field
                      v-bind="percentage_config"
                      box
                      :readonly="true"
                      v-model="fx_rate"
                      label="FX %"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm5 md6 pr-1>
                    <v-layout row wrap caption>
                      <v-flex xs12 py-0 text-xs-right v-if="!withdrawal && estimated_value_until_exchange">
                        {{i18n('Valor moeda nacional')}}: <span class="title" style="color: var(--background-color)">{{l(value, record.currency)}}</span>
                      </v-flex>
                      <v-flex xs12 py-0 text-xs-right v-if="!withdrawal">
                        {{i18n('Valor moeda estrangeira')}}: <span class="title" style="color: var(--background-color)">{{l(exchanged_value, record.exchange_currency)}}</span>
                      </v-flex>
                      <v-flex xs12 py-0 text-xs-right v-if="withdrawal && estimated_value_until_exchange">
                        {{i18n('Valor moeda estrangeira')}}: <span class="title" style="color: var(--background-color)">{{l(value, record.currency)}}</span>
                      </v-flex>
                      <v-flex xs12 py-0 text-xs-right v-if="withdrawal">
                        {{i18n('Valor moeda nacional')}}: <span class="title" style="color: var(--background-color)">{{l(exchanged_value, record.exchange_currency)}}</span>
                      </v-flex>
                      <v-flex xs12 py-0 text-xs-right>
                        {{i18n('Taxa de Câmbio FX (com IOF)')}}: <span class="subheading" style="color: var(--secondary-button-background-color)">{{parseFloat(exchange_rate).toFixed(5)}}</span>
                      </v-flex>
                      <v-flex xs12 py-0 text-xs-right>
                        {{i18n('Valor FX')}}: <span class="subheading" style="color: var(--secondary-button-background-color)">{{fx_value}}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs6 md6 pr-1>
                    <v-currency-field
                      box
                      :readonly="true"
                      v-bind="currency_config"
                      v-model="iof_value"
                      :label="i18n('Valor IOF')"
                    ></v-currency-field>
                  </v-flex>

                  <v-flex xs6 md6 pr-1></v-flex>

                  <v-flex xs12 md6 pa-1 v-on:mouseover.stop="" @click.prevent.stop="" :class="{'cursor-default': disableShowExchangeForm}">
                    <v-btn @click="cancelShowExchangeForm" dark block class="ma-0 secondary-btn-bg-color font-weight-black" :class="{'disable-events': disableShowExchangeForm, 'cursor-default': disableShowExchangeForm}">
                      {{i18n('Cancelar')}}
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 md6 pa-1 v-on:mouseover.stop="" @click.prevent.stop="" :class="{'cursor-default': disableShowExchangeForm}">
                    <v-btn @click="createExchange" block dark class="ma-0 btn-style--secondary font-weight-black" :class="{'disable-events': disableShowExchangeForm, 'cursor-default': disableShowExchangeForm}">
                      {{i18n('Registrar Operação de Câmbio')}}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </transition>

          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-divider />
  </v-flex>
</template>
<script>
import utils from "./shared/Utils"
import TransactionWithScheduleItem from "./TransactionWithScheduleItem"

export default {
  name: 'ClientExchangeAccountItem',
  components: { 'transaction': TransactionWithScheduleItem },
  props: {
    record: {
      type: Object
    },
  },
  data() {
    return {
      transactions: [],
      current_view: 'short',

      exchange_rate: 0.0,
      spot_exchange_rate: 0.0,
      iof_rate: 0.0,
      iof_value: 0.0,
      fx_rate: 0.0,
      fx_value: 0.0,

      currency: '',
      exchange_currency: '',
      from_bank_account_id: '',
      to_bank_account_id: '',
      exchanged_value: 0,
      value: 0.0,

      transactionsLoaded: 'not_loaded',
      mode: 'normal',
      submitting_data: false,
      currency_config: {
        decimal: ',',
        thousands: '.',
        precision: 2,
      },
      exchange_rate_config: {
        decimal: ',',
        thousands: '.',
        precision: 5,
      },
      percentage_config: {
        decimal: ',',
        thousands: '.',
        precision: 2,
      },
      estimated_value_until_exchange: false
    }
  },
  computed: {
    withdrawal() {
      return (
        this.$root.isLocalCurrency(this.record.exchange_currency) ||
        this.$root.isCryptoCurrency(this.record.exchange_currency)
      )
    },
    disableShowExchangeForm() {
      return this.selectedTransactions.length == 0
    },
    disableCreateExchange() {
      return this.selectedTransactions.length == 0
    },
    selectedTransactions() {
      return this.transactions.filter( ( record ) => { return record.selected } )
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    canceledTransaction(){
      this.$emit('canceledTransaction')
    },
    toogleView() {
      if (this.current_view === 'short') {
        this.loadTransactions()
        this.current_view = 'detailed'
      } else {
        this.current_view = 'short'
      }
    },
    l(number_value, currency) {
      return utils.currencyToLocal(number_value, currency)
    },
    longAccountName(account) {
      if (account === null) { return '' }
      return utils.longAccountName(account)
    },
    cancelShowExchangeForm() {
      this.mode = 'normal'
    },
    showExchangeForm() {
      if (this.disableShowExchangeForm) return null

      if (this.mode == 'normal') {
        this.mode = 'confirmation'
        return null
      } else {
        this.mode = 'creating'
      }

    },
    createExchange() {
      if (this.disableCreateExchange) { return }
      if (this.submitting_data) { return }

      let successCallback = (response) => {
        if (response.body.data) {
          this.$emit('exchangeCreated', this.record.bank_transaction_ids[0], response.body.data)
        }
      }

      let errorCallback = (response) => {
        console.log('errorCallback', response)
        this.submitting_data = false
      }
      const transactionIds = this.selectedTransactions.map(t => { return t.scheduled_bank_transaction.id })
      const payload = { exchange: { transaction_ids: transactionIds } }
      this.submitting_data = true
      let token = this.$cookies.get('api_token')
      let url = this.$root.urls.customer__exchanges
      this.$http.post(url, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    loadTransactions() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.transactions = response.body.data.map(o => { o.selected = true; return o })
          this.transactionsLoaded = 'ok'
          this.estimated_value_until_exchange = this.transactions[0].scheduled_bank_transaction.estimated_value_until_exchange
          this.exchangesCalculate()
        } else {
          this.transactionsLoaded = 'error'
          console.log('successCallback', response)
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.transactionsLoaded = 'not_authorized'
        } else {
          this.transactionsLoaded = 'error'
        }
      }

      this.transactionsLoaded = 'not_loaded'
      let token = this.$cookies.get('api_token')
      const payload = { bank_transaction_ids: this.record.bank_transaction_ids }
      let url = this.$root.urls.customer__load_bank_transactions
      this.$http.post(url, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    exchangesCalculate() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.fx_rate = (parseFloat(response.body.data.fx_rate) * 100.0).toFixed(2)
          this.fx_value = parseFloat(response.body.data.fx_value).toFixed(2)
          this.iof_rate = (parseFloat(response.body.data.iof_rate) * 100.0).toFixed(2)
          this.iof_value = parseFloat(response.body.data.iof_value).toFixed(2)

          this.exchange_rate = parseFloat(response.body.data.exchange_rate).toFixed(5)
          this.spot_exchange_rate = parseFloat(response.body.data.exchange_rate_spot).toFixed(5)
          this.exchanged_value = parseFloat(response.body.data.exchanged_value).toFixed(2)

          this.value = parseFloat(response.body.data.value)

          this.currency = response.body.data.currency
          this.exchange_currency = response.body.data.exchange_currency
          this.from_bank_account_id = response.body.data.from_bank_account_id
          this.to_bank_account_id = response.body.data.to_bank_account_id
        }
      }

      let errorCallback = (response) => {
        console.log('errorCallback', response)
      }

      let token = this.$cookies.get('api_token')
      const transactionIds = this.selectedTransactions.map(t => { return t.scheduled_bank_transaction.id })
      const payload = { exchange: { transaction_ids: transactionIds } }
      let url = this.$root.urls.customer__exchanges_calculate
      this.$http.post(url, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    handleToogleSelected(item) {
      for (let index in this.transactions) {
        if (this.transactions[index].id === item.id) {
          this.$set(this.transactions[index], 'selected', !item.selected)
        }
      }
    }
  },
  mounted() {
  }
}
</script>
<style>
  .adjust-btn-top-margin {
    margin-top: -28px;
  }
  .disable-events {
    pointer-events: none;
  }
  .cursor-default {
    cursor: default!important;
  }
  .secondary-btn-bg-color{
    color: var(--background-color)!important;
    background-color: rgba(0,0,0,.10)!important;
    height: 56px;
  }
</style>



// WEBPACK FOOTER //
// src/ClientExchangeAccountItem.vue